<div
  class="nav-container"
  *ngIf="menuExpanded"
  [class.open]="menuExpanded | async"
  [class.collapsed]="!(menuExpanded | async)">
  <div class="tenant-selection" *ngIf="(dataShareService.availableTenants$ | async).length > 1">
    <mat-form-field appearance="outline">
      <mat-label>Mandant</mat-label>
      <input type="text" matInput [formControl]="tenantFilterControl" [matAutocomplete]="auto" />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayTenant">
        <mat-option *ngFor="let item of filteredTenants | async" [value]="item" (click)="setTenant(item)">
          {{ item.displayName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <mat-action-list role="list" class="nav">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <!-- Leaf nodes or titles -->
      <mat-tree-node
        *matTreeNodeDef="let node"
        matTreeNodeToggle
        [ngClass]="{
          nav__link: node.link,
          nav__title: node.isTitle,
          'nav__link--active': currentUrl.startsWith(node.link)
        }"
        (mouseenter)="mouseEnterNode($event)">
        <mat-list-item (click)="isSelected(node)" [disableRipple]="node.isTitle">
          <span *ngIf="node.icon" class="nav__icon material-symbols-outlined notranslate">
            {{ node.icon }}
          </span>

          <span class="nav__label">
            {{ node.label }}
          </span>
        </mat-list-item>
      </mat-tree-node>

      <!-- Expandable nodes -->
      <mat-nested-tree-node
        *matTreeNodeDef="let node; when: hasChild"
        class="nav__link nav__expandable"
        (mouseenter)="mouseEnterNode($event)">
        <mat-list-item matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.label">
          <span *ngIf="node.icon" class="nav__icon material-symbols-outlined notranslate">
            {{ node.icon }}
          </span>

          <span class="nav__label">
            {{ node.label }}
          </span>

          <span class="nav__chevron material-symbols-outlined notranslate">
            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
          </span>
        </mat-list-item>

        <div
          class="nav__group"
          [class.nav__group--collapsed]="!treeControl.isExpanded(node)"
          role="group"
          (mouseenter)="mouseEnterGroup($event)"
          (mouseleave)="mouseLeaveGroup($event)">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </mat-action-list>
</div>

<mat-list class="collapse-menu-button">
  <mat-list-item
    title="Seitenmenü umschalten"
    [class.open]="menuExpanded | async"
    [class.collapsed]="!(menuExpanded | async)"
    [class.btn_open]="menuExpanded | async"
    [class.btn_collapsed]="!(menuExpanded | async)"
    (click)="toggleMenu()">
    <span class="nav__icon material-symbols-outlined notranslate">
      {{ (menuExpanded | async) ? 'chevron_left' : 'chevron_right' }}
    </span>
    <span class="nav__label">Menü verkleinern</span>
  </mat-list-item>
</mat-list>
